<template>
  <div class="feedback-fab-container" v-if="isAuthenticated">
    <!-- FAB Button -->
    <button
      class="fab-feedback"
      @click="openFeedback"
      title="Send Feedback"
      aria-label="Send Feedback"
    >
      <span class="fab-icon">?</span>
    </button>

    <!-- Success Toast -->
    <div v-if="showSuccess" class="feedback-toast success">
      Thanks for your feedback!
    </div>
  </div>
</template>

<script>
import { ref, computed } from 'vue'
import { useAuthStore } from '@/store/auth'

export default {
  name: 'FeedbackFab',
  emits: ['open-feedback'],
  setup(props, { emit }) {
    const store = useAuthStore()
    const showSuccess = ref(false)
    
    const isAuthenticated = computed(() => store.isAuthenticated)

    const openFeedback = () => {
      emit('open-feedback')
    }

    // Method to show success toast (called from parent after submission)
    const showSuccessToast = () => {
      showSuccess.value = true
      setTimeout(() => {
        showSuccess.value = false
      }, 3000)
    }

    return {
      isAuthenticated,
      showSuccess,
      openFeedback,
      showSuccessToast
    }
  }
}
</script>

<style scoped>
.feedback-fab-container {
  position: fixed;
  top: calc(80px + env(safe-area-inset-top, 0px));
  right: 20px;
  z-index: 100;
}

.fab-feedback {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: #17a2b8;
  border: none;
  color: white;
  cursor: pointer;
  box-shadow: 0 3px 10px rgba(23, 162, 184, 0.4);
  transition: transform 0.2s, box-shadow 0.2s, background 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
}

.fab-feedback .fab-icon {
  font-size: 1.4rem;
  font-weight: 700;
  line-height: 1;
}

.fab-feedback:hover {
  transform: scale(1.1);
  box-shadow: 0 5px 15px rgba(23, 162, 184, 0.5);
  background: #138496;
}

.fab-feedback:active {
  transform: scale(0.95);
}

/* Success Toast */
.feedback-toast {
  position: fixed;
  top: 130px;
  right: 20px;
  padding: 0.75rem 1.25rem;
  border-radius: 8px;
  font-size: 0.9rem;
  font-weight: 500;
  animation: toastSlide 0.3s ease-out;
  z-index: 101;
}

.feedback-toast.success {
  background: #198754;
  color: white;
}

@keyframes toastSlide {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Mobile Responsive */
@media (max-width: 768px) {
  .feedback-fab-container {
    top: calc(70px + env(safe-area-inset-top, 0px));
    right: 16px;
  }

  .fab-feedback {
    width: 40px;
    height: 40px;
  }

  .fab-feedback .fab-icon {
    font-size: 1.2rem;
  }

  .feedback-toast {
    top: 115px;
    right: 16px;
  }
}

/* PWA standalone mode */
@media (display-mode: standalone) {
  .feedback-fab-container {
    top: calc(60px + env(safe-area-inset-top, 0px));
  }
}
</style>
